import React from 'react';
import { formatDate } from '../../components/datepicker';
import { withPopupToggles } from 'startlibs/lib/hocs';

@withPopupToggles("datePicker")
export class Title extends React.Component {

  state = {};

  componentWillMount() {
    this.loadLanguage(this.props.language)
  }
  componentWillReceiveProps(newProps) {
    if (newProps.language !== this.props.language) {
      this.loadLanguage(newProps.language)
    }
  }

  loadLanguage(languageKey) {
    import(`../../components/date.i18n/${languageKey}`).then((lang)=>this.setState({lang:lang[languageKey]}))
  }

  handleChange = (e) => {
    this.modified = true;
    this.props.update({[e.target.name]:e.target.value});
  };

  autoSave = () => {
    if (this.modified) {
      this.modified = false;
      this.props.saveUpdate(this.props.reportTitle)
    }
  };

  render() {
    const { reportTitle, dateFormat } = this.props;
    const lang = this.state.lang;
    const date = new Date();
    return (
      <div className="report-title-container">
        <label className="report-title-field">
          <span className="field-label">Report title</span>
          <input className="report-title" type="text" value={reportTitle.title} maxLength={65} name="title" onChange={this.handleChange} onBlur={this.autoSave} />
        </label>
        <div className="report-date-container">
          {lang && <span className="report-date">{formatDate(date,lang, dateFormat)}</span>}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/editor/Title.js